import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from './index';

interface UIPreferencesState {
  /** Whether the view-toggle icon buttons are visible in the TranscriptionPage toolbar */
  showTranscriptionToolbarToggles: boolean;
  /** Whether the patient/exam context panels accordion is open in TranscriptionPage */
  showContextPanels: boolean;
}

const initialState: UIPreferencesState = {
  showTranscriptionToolbarToggles: true,
  showContextPanels: false,
};

const uiPreferencesSlice = createSlice({
  name: 'uiPreferences',
  initialState,
  reducers: {
    setShowTranscriptionToolbarToggles(state, action: PayloadAction<boolean>) {
      state.showTranscriptionToolbarToggles = action.payload;
    },
    toggleTranscriptionToolbarToggles(state) {
      state.showTranscriptionToolbarToggles = !state.showTranscriptionToolbarToggles;
    },
    setShowContextPanels(state, action: PayloadAction<boolean>) {
      state.showContextPanels = action.payload;
    },
    toggleContextPanels(state) {
      state.showContextPanels = !state.showContextPanels;
    },
  },
});

export const {
  setShowTranscriptionToolbarToggles,
  toggleTranscriptionToolbarToggles,
  setShowContextPanels,
  toggleContextPanels,
} = uiPreferencesSlice.actions;

export const selectShowTranscriptionToolbarToggles = (state: RootState) =>
  state.uiPreferences.showTranscriptionToolbarToggles;

export const selectShowContextPanels = (state: RootState) =>
  state.uiPreferences.showContextPanels;

export default uiPreferencesSlice.reducer;
